// דמו לתצוגת AllCakes
export const demoCakesData = [
  {
    behavior: 'התפרצות זעם',
    path: 'לאחר סיום שיעור, הילד לא רצה לעבור לפעילות הבאה',
    result: 'הילד צעק, בכה וזרק חפצים',
    percentage: 40
  },
  {
    behavior: 'אי שיתוף פעולה',
    path: 'במהלך שיעור חשבון, הילד סירב לענות לשאלות',
    result: 'הילד שתק, לא ענה ולא יצר קשר עין',
    percentage: 30
  },
  {
    behavior: 'עזיבת מקום',
    path: 'במהלך שיעור ספורט, הילד עזב את המגרש ללא רשות',
    result: 'הילד יצא מהכיתה והסתובב במסדרון',
    percentage: 30
  }
];
